import { PollsApi } from '../services/api';

export const pollsApi = new PollsApi();
